import { DashboardFilterObject } from './types';

export const defaultDashboardFilter: DashboardFilterObject = {
  targetSystemIds: [],
  timeRange: 'today',
  stateGroup: 'open',
};
